/**
 * Convierte un string tipo "1 M", "2 H", "3 S" a "1 minuto", "2 horas", "3 segundos", etc.
 * @param input Ejemplo: "1 M", "2 H", "3 S"
 * @returns string formateado en español
 */
export function formatTimeWithUnit(input: string): string {
  if (!input) return '';

  // Eliminar espacios y separar número y unidad
  const match = input.trim().match(/^(\d+)\s*([MHS])$/i);
  if (!match) return input; // Si no coincide, devolver el original

  const value = parseInt(match[1], 10);
  const unit = match[2].toUpperCase();

  let unitText = '';
  switch (unit) {
    case 'M':
      unitText = value === 1 ? 'minuto' : 'minutos';
      break;
    case 'H':
      unitText = value === 1 ? 'hora' : 'horas';
      break;
    case 'S':
      unitText = value === 1 ? 'segundo' : 'segundos';
      break;
    default:
      return input;
  }

  return `${value} ${unitText}`;
}
